import { Pipe, PipeTransform } from '@angular/core';
import { HostListenerService } from '../../services/host-listener.service';

@Pipe({
    name: 'mobileButton',
    standalone: true,
})
export class MobileButtonPipe implements PipeTransform
{
    constructor(private _host: HostListenerService) {
    }

    transform(value: string): string {
        if (this._host.smBreakpoint$.getValue()) {
            const parts = value.split(' ');
            parts.pop();
            return parts.join(' ');
        }

        return value;
    }
}
